import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { ApplicationFacade, Itinerary } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import { TicketPurchaseTimeModalData } from '@ridango/core';

@Component({
    selector: 'rwidget-journey-ticket-purchase-time-modal',
    templateUrl: './journey-ticket-purchase-time-modal.component.html',
    styleUrls: ['./journey-ticket-purchase-time-modal.component.scss']
})
export class JourneyTicketPurchaseTimeModalComponent extends BaseComponent {
    @Input() data: TicketPurchaseTimeModalData;
    @Input() itinerary: Itinerary;

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {
        super();
    }

    closeModal(): void {
        this.modalCtrl.dismiss(null, 'cancel');
    }

    confirmPurchase(): void {
        this.modalCtrl.dismiss({ action: 'buy' }, 'confirm');
    }
}
